import moment from "moment";

export function formatDeferredMovementDate(dateStr) {
    if (dateStr == null || dateStr === "") {
        return "";
    }
    const raw = String(dateStr);
    const date = raw.includes("T") ? raw.substring(0, raw.indexOf("T")) : raw;
    return moment(date).format("DD/MM/YYYY");
}

export function extractDeferredMovementsList(diferedMovements) {
    const raw = diferedMovements?.listDiferedMovements?.recuperarCuentaMovimientoDiferidoEnt;
    if (raw == null) {
        return [];
    }
    return Array.isArray(raw) ? raw : [raw];
}

export function mapDeferredMovementToRow(movement, currencyIso) {
    return {
        id: movement.numeroComprobante ?? movement.fechaIngreso,
        formattedMovementDate: formatDeferredMovementDate(movement.fechaIngreso),
        detail: movement.descripcion ?? "",
        voucherDisplay: movement.numeroComprobante ?? "",
        formattedValueDate: formatDeferredMovementDate(movement.fechaImputacion),
        currency: currencyIso,
        amount: movement.importe,
    };
}

export function buildProjectedBalanceSummary(balance, currencyIso, getSummaryLabels) {
    if (!balance) {
        return null;
    }
    const capitalReal = balance.capitalReal ?? 0;
    const capital24Horas = balance.capital24Horas ?? 0;
    const capital48Horas = balance.capital48Horas ?? 0;

    return {
        todayLabel: getSummaryLabels("todayLabel"),
        todayAmount: capitalReal,
        currency: currencyIso,
        balance24Label: getSummaryLabels("balance24Label"),
        balance24Amount: capitalReal + capital24Horas,
        balance48Label: getSummaryLabels("balance48Label"),
        balance48Amount: capitalReal + capital24Horas + capital48Horas,
    };
}

export function buildDeferredMovementsPagination(diferedMovements, onPageChange) {
    if (!diferedMovements) {
        return undefined;
    }
    const rows = extractDeferredMovementsList(diferedMovements);
    if (rows.length === 0) {
        return undefined;
    }
    const totalPages = diferedMovements.totalPages <= 0 ? 1 : diferedMovements.totalPages;
    return {
        totalPages,
        pageNumber: diferedMovements.pageNumber,
        action: onPageChange,
        justify: "end",
    };
}
